import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "flex flex-col flex-grow items-center",
  style: {"--size":"8rem"}
}
const _hoisted_2 = {
  class: "flex mt-4",
  style: {"width":"calc(var(--size) + 4rem)","height":"calc(var(--size) + 4rem)"}
}
const _hoisted_3 = { class: "image-container__animation" }
const _hoisted_4 = {
  class: "flex relative bg-white rounded-lg p-2 items-center justify-center",
  style: {"width":"var(--size)","height":"var(--size)"}
}
const _hoisted_5 = { class: "absolute w-full h-full" }
const _hoisted_6 = { class: "text-4xl" }

import BaseLoader from "@/components/BaseLoader.vue";
import { ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const qrImage = ref();
const isLoadingQrBlob = ref(true);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            (isLoadingQrBlob.value)
              ? (_openBlock(), _createBlock(BaseLoader, {
                  key: 0,
                  class: "absolute overflow-hidden rounded-lg opacity-20 flex justify-center items-center"
                }))
              : _createCommentVNode("", true)
          ]),
          _withDirectives(_createElementVNode("img", {
            ref_key: "qrImage",
            ref: qrImage,
            src: "/api/qr",
            alt: "",
            onLoad: _cache[0] || (_cache[0] = () => (isLoadingQrBlob.value = false))
          }, null, 544), [
            [_vShow, !isLoadingQrBlob.value]
          ])
        ])
      ])
    ]),
    _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$t("scanToUse")), 1)
  ]))
}
}

})